module.exports = __webpack_public_path__ + "static/media/logo-MORRIS.31f468ce.svg";